import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import {
  login,
  register,
  updateProfile,
  logout
} from '../redux/slices/authJwt';
import { forgotPassword, confirmForgotPassword } from '../redux/slices/user';

// ----------------------------------------------------------------------

useAuth.propTypes = {
  method: PropTypes.oneOf(['jwt'])
};

/* eslint-disable consistent-return */
export default function useAuth(method = 'jwt') {
  // JWT Auth
  const dispatch = useDispatch();
  const { user, isLoading, isAuthenticated } = useSelector(
    (state) => state.authJwt
  );

  // JWT Auth
  if (method === 'jwt') {
    return {
      method: 'jwt',
      user,
      isLoading,
      isAuthenticated,

      login: ({ email, password }) =>
        dispatch(
          login({
            email,
            password
          })
        ),

      register: ({ email, password, firstName, lastName, company }) =>
        dispatch(
          register({
            email,
            password,
            firstName,
            lastName,
            company
          })
        ),

      logout: () => dispatch(logout()),

      resetPassword: (email) => {
        dispatch(forgotPassword(email));
      },

      confirmForgotPassword: (email, code, newPassword) => {
        dispatch(confirmForgotPassword(email, code, newPassword));
      },

      // updateProfile: ({ email, phoneNumber, firstName, lastName }) =>
      //   dispatch(updateProfile(email, phoneNumber, firstName, lastName))
      updateProfile: async ({ email, phoneNumber, firstName, lastName }) => {
        try {
          await dispatch(
            updateProfile(email, phoneNumber, firstName, lastName)
          );
          return { success: true };
        } catch (error) {
          // console.error('Profile update failed:', error);
          return { success: false, error };
        }
      }
    };
  }
}
